import ShopAlertDialog from "@/shop/components/dialogs/ShopAlertDialog.vue"
import ShopConfirmDialog, { type ShopConfirmDialogOptions } from "@/shop/components/dialogs/ShopConfirmDialog.vue"
import { DialogController, useDialogs } from "@/vf"
import { h, type RenderFunction, type VNode } from "vue"
import ShopLoadingDialog from "@/shop/components/dialogs/ShopLoadingDialog.vue"

export function useShopDialogs() {
    const { open } = useDialogs()

    async function confirm(
        title: string,
        message: string | RenderFunction,
        options?: {
            yesButton?: (controller: DialogController<boolean, ShopConfirmDialogOptions>) => VNode
            noButton?: (controller: DialogController<boolean, ShopConfirmDialogOptions>) => VNode
        },
    ): Promise<boolean> {
        options ??= {}
        options.yesButton ??= controller =>
            h(
                "button",
                {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: () => controller.ok(true),
                },
                "Ja",
            )
        options.noButton ??= controller =>
            h(
                "button",
                {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: () => controller.cancel(),
                },
                "Nein",
            )

        return (
            await open({
                component: ShopConfirmDialog,
                props: {
                    title,
                    message,
                    ...options,
                },
            })
        ).output as boolean
    }

    async function alert(title: string, message: string | VNode): Promise<void> {
        await open({
            component: ShopAlertDialog,
            props: {
                title,
                message,
                buttons: [],
            },
        })
    }

    function loading(message: string): DialogController<void> {
        return open({
            component: ShopLoadingDialog,
            props: { message },
        })
    }

    return {
        confirm,
        alert,
        loading,
    }
}
